import {
  ChartApiRequest,
  ChartApiResponse,
  serializeQuery,
} from '../Components/ReportCharts/ReportDataTransform';
import { BASE_PATH } from '../__mocks__/api';

export const fetchChartData = async (requestObj: ChartApiRequest): Promise<ChartApiResponse> => {
  let fetchUrl = `${BASE_PATH}/reportdata`;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: serializeQuery(requestObj),
  };

  // From Aug 1 2018 - To July 31 2019. For product Bookflix, Data is broken
  // This logic fixes broken data.
  if (
    requestObj.product &&
    requestObj.product[0] === 'bkflix' &&
    requestObj.request !== 'documentUsageByGroup' &&
    requestObj.request !== 'sessionUsageByGroup'
  ) {
    const response = await (await fetch(fetchUrl, requestOptions)).json();
    const keys = Object.keys(response.result);

    for (let j = 0; j < keys.length; j++) {
      if (dateIsBetweenBrokenInterval(new Date(keys[j]))) {
        response.result[keys[j]].individual.sessions = calculateBrokenSessions(
          response.result[keys[j]].individual.documents,
        );
        response.result[keys[j]].onsite.sessions = calculateBrokenSessions(
          response.result[keys[j]].onsite.documents,
        );
        response.result[keys[j]].remote.sessions = calculateBrokenSessions(
          response.result[keys[j]].remote.documents,
        );
      }
    }

    return response;
  } else {
    return await (await fetch(fetchUrl, requestOptions)).json();
  }
};

const BROKEN_START = Date.parse(new Date('2018-08-01').toISOString());
const BROKEN_END = Date.parse(new Date('2019-07-31').toISOString());

const dateIsBetweenBrokenInterval = (date: Date) => {
  const givenDate = Date.parse(date.toISOString());
  return givenDate >= BROKEN_START && givenDate <= BROKEN_END;
};

const calculateBrokenSessions = (documents: number) => {
  return documents ? Math.round(documents / 2.4) : 0;
};
